(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["leyl-newsletter"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    document.querySelectorAll('[data-leyl-newsletter]').forEach(function(frame){
      if(frame.dataset.ready)return;
      frame.dataset.ready='true';
      var form=frame.querySelector('.leyl-newsletter__form');
      var emailInput=form&&form.querySelector('input[name="contact[email]"]');
      var success=form&&form.querySelector('[data-leyl-newsletter-success]');
      var alreadyBox=form&&form.querySelector('[data-leyl-newsletter-already]');
      var storagePrefix='leyl-newsletter-known-v1:';
      var pendingKey='leyl-newsletter-pending-v1';
      function emailKey(value){
        var email=(value||'').trim().toLowerCase();
        if(!email)return '';
        var hash=2166136261;
        for(var i=0;i<email.length;i++){hash^=email.charCodeAt(i);hash=Math.imul(hash,16777619);}
        return storagePrefix+(hash>>>0).toString(16);
      }
      if(form&&emailInput){
        form.addEventListener('submit',function(){
          var key=emailKey(emailInput.value);
          if(!key)return;
          try{
            sessionStorage.setItem(pendingKey,JSON.stringify({key:key,already:localStorage.getItem(key)==='1'}));
          }catch(error){}
        });
        try{
          var pending=JSON.parse(sessionStorage.getItem(pendingKey)||'null');
          var current=emailKey(emailInput.value);
          var matches=pending&&pending.key&&(!current||pending.key===current);
          var error=form.querySelector('[role="alert"]');
          var params=new URLSearchParams(window.location.search);
          var shopifyResubmission=params.get('form_type')==='customer';
          if(success){
            if(matches){
              if(pending.already)success.textContent=success.getAttribute('data-already-message');
              localStorage.setItem(pending.key,'1');
            }else if(current){
              localStorage.setItem(current,'1');
            }
            sessionStorage.removeItem(pendingKey);
          }else if(!error&&alreadyBox&&shopifyResubmission&&current){
            /* Shopify sometimes returns existing addresses with no success and form_type=customer. */
            alreadyBox.hidden=false;
            localStorage.setItem(current,'1');
            sessionStorage.removeItem(pendingKey);
          }else if(error){
            sessionStorage.removeItem(pendingKey);
          }
        }catch(error){}
      }
      var videos=Array.from(frame.querySelectorAll('video'));
      var reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
      var paused=reduce.matches;
      function update(){
        videos.forEach(function(video){
          var rect=video.getBoundingClientRect();
          var visible=rect.bottom>0&&rect.top<window.innerHeight;
          if(paused||document.hidden||!visible)video.pause();
          else video.play().catch(function(){});
        });
      }
      if('IntersectionObserver' in window){
        var observer=new IntersectionObserver(update);
        videos.forEach(function(video){observer.observe(video);});
      }
      reduce.addEventListener('change',function(event){paused=event.matches;update();});
      document.addEventListener('visibilitychange',update);
      update();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
